import { styled, useTheme } from "@mui/material/styles";


import {
  Box,
 
  Typography,
  IconButton,
  List,
  ListItemText,

  ListItem,
  ListItemAvatar,
  Divider,
  Avatar,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";


import React from "react";
import AppBar from "../appBar/AppBar";
import MuiAppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";
import { items } from "../../utils/drawerItems";
import useStyle from "./drawerStyle.js";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const drawerWidth = 240;

export default function ResponsiveDrawer() {
  const theme = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const classes = useStyle();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  function logOut() {
    localStorage.setItem("isLogin", "false");
    window.location.reload();
  }
  function itemClick(index) {
    console.log("index");
    handleDrawerClose();
    switch (index) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/profile");
        break;
      case 2:
        navigate("/users");
        break;
      case 3:
        navigate("/categories");
        break;

      case 4:
        navigate("/products");
        break;

      case 5:
        navigate("/orders");
        break;

        break;

      case 6:
        navigate("/invoices");

        break;
      case 7:
        navigate("/sales");

        break;
      case 8:
        navigate("/administrators");

        break;
      case 9:
        logOut();

        break;
      default:
        navigate("/");
    }
  }

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar open={open} handleDrawerOpen={handleDrawerOpen} />
      <Drawer
        className={classes.drawer}
        variant="persistent"
        
        //anchor={i18n.dir() === 'ltr' ?"left":"right"}
        open={open}
      >
        <DrawerHeader className={classes.drawerHeader}>
        <ListItem>
                    <ListItemAvatar>
                      <Avatar
                       
                      />
                    </ListItemAvatar>
                    <ListItemText primary="hussein" secondary="husseinayyad70@gmail.com" />
                  </ListItem>
          {/* <Typography
            variant="h7"
            component="div"
            className={classes.headerTitle}
          >
            {t("adminPanel")}
          </Typography> */}
          <IconButton onClick={handleDrawerClose}>
            {i18n.dir() === "ltr" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
          
        </DrawerHeader>
      
        <List>
          <Divider/>
          {items.text.map((text, index) => (
            <ListItem
              className={classes.listItem}
              button
              key={text}
              onClick={() => itemClick(index)}
            >
              {<div className={classes.itemIcon}> {items.icons[index]}</div>}
              <Typography className={classes.itemText}>{t(text)}</Typography>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
      </Main>
    </Box>
  );
}
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,

    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const ApBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));
